module.exports = "/1/7-pham-vi-cua-bien/index.html.7b8e3af7da9532eb3642eb19b7367ed9.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29939.md
 ** module id = 536
 ** module chunks = 0
 **/